import { Group, Button, TextInput, NumberInput, Select, Switch } from '@mantine/core';

import { useUpdateWithdrawalMethod } from '../hooks/use-update-withdrawal-method';

import type { TWithdrawalMethod } from '../store/types';

type Props = {
  method: TWithdrawalMethod;
  onClose: () => void;
};

export const WithdrawalMethodUpdateForm = (props: Props) => {
  const { onClose, method } = props;
  const {
    avalableCurrencies,
    form,
    // isLoading,
    handleSubmit,
  } = useUpdateWithdrawalMethod({ withdrawalMethod: method, onClose });

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <NumberInput
        label="ID вывода"
        withAsterisk
        disabled
        key={form.key('methodId')}
        {...form.getInputProps('methodId')}
      />
      <TextInput
        label="Название"
        withAsterisk
        key={form.key('name')}
        {...form.getInputProps('name')}
      />
      <Select
        label="Валюта"
        withAsterisk
        data={avalableCurrencies.map((currency) => ({ value: currency, label: currency }))}
        key={form.key('currency')}
        {...form.getInputProps('currency')}
      />
      <NumberInput
        label="Минимальная сумма вывода"
        withAsterisk
        key={form.key('minAmount')}
        {...form.getInputProps('minAmount')}
      />
      <NumberInput
        label="Максимальная сумма вывода"
        withAsterisk
        key={form.key('maxAmount')}
        {...form.getInputProps('maxAmount')}
      />
      <NumberInput
        label="Процент вывода"
        withAsterisk
        key={form.key('withdrawalPercent')}
        {...form.getInputProps('withdrawalPercent')}
      />
      <NumberInput
        label="Фикс"
        withAsterisk
        key={form.key('withdrawalFee')}
        {...form.getInputProps('withdrawalFee')}
      />

      <Switch
        mt={10}
        label="Активен"
        key={form.key('active')}
        {...form.getInputProps('active', { type: 'checkbox' })}
      />

      <Group justify="flex-end" mt="30">
        <Button variant="outline" onClick={() => onClose()}>
          Отменить
        </Button>
        <Button type="submit">
          Сохранить
        </Button>
      </Group>
    </form>
  );
};
